import Button from '@mui/material/Button';
import { lightBlue } from '@mui/material/colors';
import React from 'react';
import { Link } from 'react-router-dom';

const colorBlue = lightBlue[200];

const styles: Record<string, React.CSSProperties> = {
    root: {
        textTransform: 'none',
        fontSize: '1.4rem',
        color: colorBlue,
    },
    round: {
        width: '2rem',
        height: '2rem',
        lineHeight: '1.8rem',
        background: 'black',
        border: `2px solid ${colorBlue}`,
        borderRadius: '100%',
        textAlign: 'center',
        justifyContent: 'space-around',
        color: 'white',
    },
    number: {
        position: 'relative',
        top: '0.4rem',
        color: 'white',
        fontWeight: 700,
    },
};

export const LogoButton = () => (
    <Button disableElevation sx={styles.root} size="large" variant="contained" color="primary" component={Link} to="/">
        <span style={styles.round}>A</span>DaMS
        <span style={styles.number}>3</span>
    </Button>
);
